import { applyMiddleware, createStore, combineReducers } from 'redux'
import promiseMiddleware from 'redux-promise-middleware'
import { composeWithDevTools } from 'redux-devtools-extension'
import reducer from './reducer'
import judgingSetupReducer from './judgingSetup/reducer'


const rootReducer = combineReducers({
  main: reducer,
  judgingSetup: judgingSetupReducer
})

const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(promiseMiddleware)))

export default store